module.exports = {
    // TRAVEL REQUEST FORMS
    CREATE_TRF: "CREATE_TRF",
    CREATE_TRF_REQUEST: "CREATE_TRF_REQUEST",
    CREATE_TRF_FAIL: "CREATE_TRF_FAIL",
    SUBMIT_TRF: "SUBMIT_TRF",
    SUBMIT_TRF_REQUEST: "SUBMIT_TRF_REQUEST",
    SUBMIT_TRF_FAIL: "SUBMIT_TRF_FAIL",
    UPDATE_TRF: "UPDATE_TRF",
    UPDATE_TRF_REQUEST: "UPDATE_TRF_REQUEST",
    UPDATE_TRF_FAIL: "UPDATE_TRF_FAIL",
    DELETE_TRF: "DELETE_TRF",
    DELETE_TRF_REQUEST: "DELETE_TRF_REQUEST",
    DELETE_TRF_FAIL: "DELETE_TRF_FAIL",
    GET_TRFS: "GET_TRFS",
    GET_TRFS_REQUEST: "GET_TRFS_REQUEST",
    GET_TRFS_FAIL: "GET_TRFS_FAIL",
    GET_TRF: "GET_TRF",
    GET_TRF_REQUEST: "GET_TRF_REQUEST",
    GET_TRF_FAIL: "GET_TRF_FAIL",
    
    GET_MINE_TRFS: "GET_MINE_TRFS",
    GET_MINE_TRFS_REQUEST: "GET_MINE_TRFS_REQUEST",
    GET_MINE_TRFS_FAIL: "GET_MINE_TRFS_FAIL",

    GET_EXTERNAL_TRFS: "GET_EXTERNAL_TRFS",
    GET_EXTERNAL_TRFS_REQUEST: "GET_EXTERNAL_TRFS_REQUEST",
    GET_EXTERNAL_TRFS_FAIL: "GET_EXTERNAL_TRFS_FAIL",
    
    GET_INTERNAL_TRFS: "GET_INTERNAL_TRFS",
    GET_INTERNAL_TRFS_REQUEST: "GET_INTERNAL_TRFS_REQUEST",
    GET_INTERNAL_TRFS_FAIL: "GET_INTERNAL_TRFS_FAIL",
    
    GET_APPROVED_TRFS: "GET_APPROVED_TRFS",
    GET_APPROVED_TRFS_REQUEST: "GET_APPROVED_TRFS_REQUEST",
    GET_APPROVED_TRFS_FAIL: "GET_APPROVED_TRFS_FAIL",
   
    APPROVE_TRF: "APPROVE_TRF",
    APPROVE_TRF_REQUEST: "APPROVE_TRF_REQUEST",
    APPROVE_TRF_FAIL: "APPROVE_TRF_FAIL",
    REJECT_TRF: "REJECT_TRF",
    REJECT_TRF_REQUEST: "REJECT_TRF_REQUEST",
    REJECT_TRF_FAIL: "REJECT_TRF_FAIL",

    ACCEPT_TRF: "ACCEPT_TRF",
    ACCEPT_TRF_REQUEST: "ACCEPT_TRF_REQUEST",
    ACCEPT_TRF_FAIL: "ACCEPT_TRF_FAIL",
    DECLINE_TRF: "DECLINE_TRF",
    DECLINE_TRF_REQUEST: "DECLINE_TRF_REQUEST",
    DECLINE_TRF_FAIL: "DECLINE_TRF_FAIL",

    REVIEW_TRF: "REVIEW_TRF",
    REVIEW_TRF_REQUEST: "REVIEW_TRF_REQUEST",
    REVIEW_TRF_FAIL: "REVIEW_TRF_FAIL",

    UNACCEPT_TRF: "UNACCEPT_TRF",
    UNACCEPT_TRF_REQUEST: "UNACCEPT_TRF_REQUEST",
    UNACCEPT_TRF_FAIL: "UNACCEPT_TRF_FAIL",

    RESET_TRF: "RESET_TRF",


    // ACCOMMODATION BOOKING
    CREATE_ACR: "CREATE_ACR",
    CREATE_ACR_REQUEST: "CREATE_ACR_REQUEST",
    CREATE_ACR_FAIL: "CREATE_ACR_FAIL",
    SUBMIT_ACR: "SUBMIT_ACR",
    SUBMIT_ACR_REQUEST: "SUBMIT_ACR_REQUEST",
    SUBMIT_ACR_FAIL: "SUBMIT_ACR_FAIL",
    UPDATE_ACR: "UPDATE_ACR",
    UPDATE_ACR_REQUEST: "UPDATE_ACR_REQUEST",
    UPDATE_ACR_FAIL: "UPDATE_ACR_FAIL",
    DELETE_ACR: "DELETE_ACR",
    DELETE_ACR_REQUEST: "DELETE_ACR_REQUEST",
    DELETE_ACR_FAIL: "DELETE_ACR_FAIL",
    GET_ACRS: "GET_ACRS",
    GET_ACRS_REQUEST: "GET_ACRS_REQUEST",
    GET_ACRS_FAIL: "GET_ACRS_FAIL",
    GET_ACR: "GET_ACR",
    GET_ACR_REQUEST: "GET_ACR_REQUEST",
    GET_ACR_FAIL: "GET_ACR_FAIL",

    APPROVE_ACR: "APPROVE_ACR",
    APPROVE_ACR_REQUEST: "APPROVE_ACR_REQUEST",
    APPROVE_ACR_FAIL: "APPROVE_ACR_FAIL",
    REJECT_ACR: "REJECT_ACR",
    REJECT_ACR_REQUEST: "REJECT_ACR_REQUEST",
    REJECT_ACR_FAIL: "REJECT_ACR_FAIL",

    ACCEPT_ACR: "ACCEPT_ACR",
    ACCEPT_ACR_REQUEST: "ACCEPT_ACR_REQUEST",
    ACCEPT_ACR_FAIL: "ACCEPT_ACR_FAIL",
    DECLINE_ACR: "DECLINE_ACR",
    DECLINE_ACR_REQUEST: "DECLINE_ACR_REQUEST",
    DECLINE_ACR_FAIL: "DECLINE_ACR_FAIL",

    RESET_ACR: "RESET_ACR",

    
    // VISA APPLICATION
    CREATE_VISA: "CREATE_VISA",
    CREATE_VISA_REQUEST: "CREATE_VISA_REQUEST",
    CREATE_VISA_FAIL: "CREATE_VISA_FAIL",
    SUBMIT_VISA: "SUBMIT_VISA",
    SUBMIT_VISA_REQUEST: "SUBMIT_VISA_REQUEST",
    SUBMIT_VISA_FAIL: "SUBMIT_VISA_FAIL",
    UPDATE_VISA: "UPDATE_VISA",
    UPDATE_VISA_REQUEST: "UPDATE_VISA_REQUEST",
    UPDATE_VISA_FAIL: "UPDATE_VISA_FAIL",
    DELETE_VISA: "DELETE_VISA",
    DELETE_VISA_REQUEST: "DELETE_VISA_REQUEST",
    DELETE_VISA_FAIL: "DELETE_VISA_FAIL",
    GET_VISAS: "GET_VISAS",
    GET_VISAS_REQUEST: "GET_VISAS_REQUEST",
    GET_VISAS_FAIL: "GET_VISAS_FAIL",
    GET_VISA: "GET_VISA",
    GET_VISA_REQUEST: "GET_VISA_REQUEST",
    GET_VISA_FAIL: "GET_VISA_FAIL",

    APPROVE_VISA: "APPROVE_VISA",
    APPROVE_VISA_REQUEST: "APPROVE_VISA_REQUEST",
    APPROVE_VISA_FAIL: "APPROVE_VISA_FAIL",
    REJECT_VISA: "REJECT_VISA",
    REJECT_VISA_REQUEST: "REJECT_VISA_REQUEST",
    REJECT_VISA_FAIL: "REJECT_VISA_FAIL",

    ACCEPT_VISA: "ACCEPT_VISA",
    ACCEPT_VISA_REQUEST: "ACCEPT_VISA_REQUEST",
    ACCEPT_VISA_FAIL: "ACCEPT_VISA_FAIL",
    DECLINE_VISA: "DECLINE_VISA",
    DECLINE_VISA_REQUEST: "DECLINE_VISA_REQUEST",
    DECLINE_VISA_FAIL: "DECLINE_VISA_FAIL",

    RESET_VISA: "RESET_VISA",
};
